import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminMe, getAdminToken, clearAdminToken } from "@/lib/api";

export default function ProtectedRoute({ children }) {
    const [status, setStatus] = useState("checking"); // checking | ok | fail

    useEffect(() => {
        const token = getAdminToken();
        if (!token) {
            setStatus("fail");
            return;
        }
        adminMe()
            .then((u) => {
                if (u && u.role === "admin") setStatus("ok");
                else {
                    clearAdminToken();
                    setStatus("fail");
                }
            })
            .catch(() => {
                clearAdminToken();
                setStatus("fail");
            });
    }, []);

    if (status === "checking") {
        return (
            <div
                className="min-h-screen flex items-center justify-center bg-[#0A1547]"
                data-testid="auth-loading"
            >
                <div className="text-[#C8A064] font-serif-display text-xl pulse-brass">
                    Authenticating...
                </div>
            </div>
        );
    }
    if (status === "fail") return <Navigate to="/admin/login" replace />;
    return children;
}
